import React from 'react';
import {useToast} from '../ui/use-toast';
import {Button} from '../ui/button'
import {Copy} from 'lucide-react';
import {copyToClipboard, copyTableToClipboard, copySheetDataToClipboard} from '../project_conf/datasheetHelpers';
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";
import {Share1Icon} from "@radix-ui/react-icons";

// type TableData = {
//     columns: { Header: string; accessor: string }[];
//     data: { [key: string]: any }[]; 
//   };

type CopyButtonProps = {
    dataToCopy?: any;
    isDataSheed?: boolean;
}

const CopyButton: React.FC<CopyButtonProps> = ({dataToCopy, isDataSheed = false}) => {
    const {toast} = useToast();

    const handleCopy = () => {
        console.log(dataToCopy)

        try {
            if (isDataSheed) {
                copySheetDataToClipboard(dataToCopy)
            } else {
                copyTableToClipboard(dataToCopy)
            }
            toast({
                title: 'Data Copied!',
                description: 'The data has been copied to your clipboard.',
                variant: 'default',
            });
        } catch (err) {
            console.log(err)
            toast({
                title: 'Error',
                description: 'Failed to copy data!',
                variant: 'destructive',
            })
        }
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger>
                        <Button onClick={handleCopy} type='button' variant="outline">
                            <Copy width={17} height={17} /></Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Copy Data to Excel</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>

)
    ;
};


type CopyButtonProps2 = {
    dataTransform: () => any;
    executeCustomCopy?: (data: any) => any
}

export function CopyButton2 ({dataTransform, executeCustomCopy}: CopyButtonProps2) {
    const {toast} = useToast();

    const handleCopy = () => {
        try {
            const items = dataTransform()
            if (executeCustomCopy) {
                executeCustomCopy(items)
            } else {
                copyTableToClipboard(items);
            }
            toast({
                title: 'Data Copied!',
                description: 'Data is ready to paste in excel',
                variant: 'default',
            });
        } catch (err) {
            console.log(err)
            toast({
                title: 'Error',
                description: 'Failed to copy data!',
                variant: 'destructive',
            })
        }
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                        <Button onClick={handleCopy} type='button' variant="outline">
                            <Copy width={17} height={17} /></Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Copy Data to Excel</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>) ;
};

export default CopyButton;
